import {reactive} from 'vue'

export const user = reactive({
	"username": "",
	"email": "",
	"password": "",
	"phone": "",
	"phoneVerificationMethod": "",
	"jwt": "",
	"captcha": "",
	"loginData": "",
	"platform": "",
	"isPasskeyAvailable": false,
	"isPasskeyTurnedOn": false,
	"passkeys": [],
	"rememberDevice": true,
	"bypassEmailCheck": false,
	"isPending2FAVerification": false,
	"validateId": '',
	"validateId2": '',
	"appName": '',
	"appTradeName": '',
	"appYear": '',
	"verifyTwoFactorData": '',
})